import { useCompanyData } from '@/hooks/useData'
import { Phone, Mail, MapPin, Clock, CloudCog, Smartphone } from 'lucide-react'
import MapComponent from '@/components/Amap';


export default function Contact() {
  const { data: companyData } = useCompanyData()

  return (
    <div className="min-h-screen bg-white">
      {/* 联系信息 */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* 联系信息 */}
            <div>
              <h2 className="section-title">联系方式</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-primary-100 p-3 rounded-lg mr-4">
                    <Phone className="h-6 w-6 text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">电话咨询</h3>
                    <p className="text-secondary-600">{companyData?.contact.phone}</p>
                    <p className="text-sm text-secondary-500">工作日 9:00-18:00</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-primary-100 p-3 rounded-lg mr-4">
                    <Smartphone className="h-6 w-6 text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">手机联系</h3>
                    <p className="text-secondary-600">{companyData?.contact.mobile}</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-primary-100 p-3 rounded-lg mr-4">
                    <Mail className="h-6 w-6 text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">邮箱联系</h3>
                    <p className="text-secondary-600">{companyData?.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-primary-100 p-3 rounded-lg mr-4">
                    <MapPin className="h-6 w-6 text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">公司地址</h3>
                    <p className="text-secondary-600">{companyData?.contact.address}</p>
                    <p className="text-sm text-secondary-500">欢迎实地考察</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-primary-100 p-3 rounded-lg mr-4">
                    <Clock className="h-6 w-6 text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">工作时间</h3>
                    <p className="text-secondary-600">周一至周五 9:00-18:00</p>
                    <p className="text-sm text-secondary-500">节假日休息</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-primary-100 p-3 rounded-lg mr-4">
                    <CloudCog className="h-6 w-6 text-primary-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">检验检测报告查询</h3>
                    <p className="text-secondary-600">电话查询：路女士  0371-67116867</p>
                    <p className="text-sm text-secondary-500">邮件查询：hnaedhb@163.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 在线留言表单 */}
            <div>
              {/* <h2 className="section-title">在线留言</h2> */}
              <MapComponent></MapComponent>
              {/* <form className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-secondary-700 mb-1">
                      姓名 *
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="请输入您的姓名"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-secondary-700 mb-1">
                      电话 *
                    </label>
                    <input
                      type="tel"
                      className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="请输入您的联系电话"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-secondary-700 mb-1">
                    邮箱
                  </label>
                  <input
                    type="email"
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="请输入您的邮箱地址"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-secondary-700 mb-1">
                    公司名称
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="请输入您的公司名称"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-secondary-700 mb-1">
                    咨询内容 *
                  </label>
                  <textarea
                    rows={4}
                    className="w-full px-3 py-2 border border-secondary-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                    placeholder="请详细描述您的需求或问题"
                    required
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full btn-primary"
                >
                  提交留言
                </button>
              </form> */}
            </div>
          </div>
        </div>
      </section>

      {/* 服务范围 */}
      <section className="py-16 bg-secondary-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="section-title">服务范围</h2>
            <p className="section-subtitle">
              为不同行业提供专业的环保技术服务
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="card text-center">
              <div className="text-4xl mb-4">🏭</div>
              <h3 className="text-lg font-semibold mb-2">石化行业</h3>
              <p className="text-secondary-600">
                LDAR检测、VOCs治理、环保合规咨询
              </p>
            </div>
            <div className="card text-center">
              <div className="text-4xl mb-4">⚗️</div>
              <h3 className="text-lg font-semibold mb-2">化工行业</h3>
              <p className="text-secondary-600">
                泄漏检测、环保评估、技术培训
              </p>
            </div>
            <div className="card text-center">
              <div className="text-4xl mb-4">💊</div>
              <h3 className="text-lg font-semibold mb-2">制药行业</h3>
              <p className="text-secondary-600">
                环保检测、合规管理、设备销售
              </p>
            </div>
            <div className="card text-center">
              <div className="text-4xl mb-4">🏢</div>
              <h3 className="text-lg font-semibold mb-2">其他行业</h3>
              <p className="text-secondary-600">
                环保咨询、技术培训、设备维护
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 合作流程 */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="section-title">合作流程</h2>
            <p className="section-subtitle">
              简单高效的合作流程，为您提供优质服务
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                1
              </div>
              <h3 className="text-lg font-semibold mb-2">需求沟通</h3>
              <p className="text-secondary-600">
                了解客户需求，制定初步方案
              </p>
            </div>
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                2
              </div>
              <h3 className="text-lg font-semibold mb-2">方案制定</h3>
              <p className="text-secondary-600">
                制定详细的技术方案和报价
              </p>
            </div>
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                3
              </div>
              <h3 className="text-lg font-semibold mb-2">项目实施</h3>
              <p className="text-secondary-600">
                专业团队执行项目，确保质量
              </p>
            </div>
            <div className="text-center">
              <div className="bg-primary-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                4
              </div>
              <h3 className="text-lg font-semibold mb-2">售后服务</h3>
              <p className="text-secondary-600">
                提供持续的技术支持和售后服务
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
} 
